import { useMe } from "@auth/useMe"
import { createFileRoute } from "@tanstack/react-router"
import { Box, Button, Flex, Text } from "@ui"
import type { FC } from "react"

import { webhooksQuery } from "../-shared/webhooks.query"
import { queryClient } from "../../../queryClient"
import { WebhookLogModal } from "./-components/WebhookLogModal"
import { WebhookModal } from "./-components/WebhookModal"
import { WebhooksList } from "./-components/WebhooksList"

const WebhooksPage: FC = () => {
  const { solutionUid } = useMe()

  return (
    <Flex
      flexDirection="column"
      gap="lg"
      padding="lg"
      width="full"
      alignSelf="flex-start"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Text textStyle="pageTitle">Webhooks</Text>
          <Text textStyle="description">
            Webhooks are used to send events to your external systems when
            certain actions occur in your solution.
          </Text>
        </Box>
        <Flex
          gap="sm"
          alignItems="center"
        >
          <Button
            onClick={() => {
              WebhookLogModal.open({ solutionUid })
            }}
          >
            Webhook log
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              WebhookModal.open({})
            }}
          >
            Create webhook
          </Button>
        </Flex>
      </Flex>
      <WebhooksList />
    </Flex>
  )
}

export const Route = createFileRoute("/_authenticated/webhooks/")({
  loader: () => {
    return queryClient.ensureQueryData(webhooksQuery())
  },
  component: WebhooksPage,
})
